import React from 'react'

const TitleH3 = ({ children }) => {
    return (
        <h3 style={{ fontSize: '14px', fontWeight: 700, margin: 0 }}>{children}</h3>
    )
}

export default TitleH3